import script from "./tool-header-button-dropdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./tool-header-button-dropdown.vue?vue&type=script&setup=true&lang=ts"

import "./tool-header-button-dropdown.vue?vue&type=style&index=0&id=939626f6&lang=scss"

const __exports__ = script;

export default __exports__